/**
 * Copyright 2026 Perform Content Services Limited. Confidential and Proprietary. All Rights Reserved.
 */

import PropTypes from 'prop-types';
import {FullScreenMessage} from '../shared/components';
import ChannelView from './components/ChannelView/ChannelView';

const App = ({config}) => {
  if (!config.subscriber.token) {
    return <FullScreenMessage messages={['Error: No token provided']} />;
  }

  return <ChannelView subscriber={config.subscriber} environment={config.environment} audio={config.audio} />;
};

App.propTypes = {config: PropTypes.object.isRequired};

export default App;